import React, {Component} from 'react'
import Prismic from 'prismic-javascript'
import { PrismicConfig } from '../../../../helpers/prismicHelpers/PrismicAPI'
import { LanguagePrismicHelper } from '../../../../helpers/prismicHelpers/PrismicHelpers'
import { prismicSliceHelper, prismicSliceContentRelationship } from '../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers'
import { sliceComponentsHelper } from '../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers'
import Loader from '../../../common/elements/Loader'

class SliceTestPage extends Component {

  state = {
    slices: null
  }

  async componentDidMount() {
    //prismic
    const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, { accessToken: PrismicConfig.apiAccessTokes });
    const json = await prismicConnection.query(Prismic.Predicates.at('my.flexible-layout.uid', 'slices-test-page'), LanguagePrismicHelper());
    let { slices } = prismicSliceHelper(json);
    slices = (slices && slices.length) ? await prismicSliceContentRelationship(slices, prismicConnection) : null;
    this.setState({ slices })
  };

  render() {

    const { slices } = this.state;

    if (!slices) return <Loader />

    return (
      <React.Fragment>
        {sliceComponentsHelper(slices)}
      </React.Fragment>
     
    )
  }
}

export default SliceTestPage;




// WEBPACK FOOTER //
// src/client/components/site/features/slices-test-page/SlicesTestPage.js